export default {
  billingInfo: 'Fakturačné údaje',
  companyName: 'Meno spoločnosti'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/company.js